"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OperationReservationModel", {
    enumerable: true,
    get: function() {
        return OperationReservationModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const OperationReservationModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    kind: _zod.z.string(),
    key: _zod.z.string(),
    task_id: _zod.z.instanceof(_bson.ObjectId),
    expires_at: _zod.z.date(),
    created_at: _zod.z.date()
});
